module.exports = __webpack_public_path__ + "media/images/vr/games/azura/azura-logo-f5b12ca7c7ea18e1b038edaf039457c0.png";